import React from "react";
import { useMap, GeoJSON } from "react-leaflet";
import { useState, useEffect } from "react";
import buffer from "@turf/buffer";
import * as turf from "@turf/turf";
import { useDispatch } from "react-redux";
import { closeTools } from "../../../features/tools/toolsSlice";
import styled from "styled-components";
import close from "../../../pic/close.png";
import markerloc from "../../../pic/markerloc.png";
import line from "../../../pic/line.png";
import poly from "../../../pic/poly.png";

import classes from "./ToolsPanel.module.css"
import L from "leaflet";
const Measure = ({ tools }) => {

  let map = useMap();
  const dispatch = useDispatch();
  const [units, setUnits] = useState();
  const [length, setLength] = useState();
  const [area, setArea] = useState();
  const [latlng, setLatlng] = useState([0, 0]);
  const [mode, setMode] = useState();

  useEffect(
    () => () => {
      map.eachLayer(function (layer) {
        if (layer.pm != null) {
          layer.remove();
        }
      });
    },
    []
  );
  map.on("pm:create", (e) => {
    if (e.shape === "Marker") {
      var point = turf.point([e.layer._latlng.lng, e.layer._latlng.lat]);
      setLatlng([e.layer._latlng.lng, e.layer._latlng.lat])
      map.pm.disableDraw();
    } else if (e.shape == "Polygon") {
      let cords = e.layer._latlngs;
      let ccds1 = cords[0].map((e) => [e.lng, e.lat]);
      ccds1.push(ccds1[0]);
      var point = turf.polygon([ccds1], { name: "poly1" });
      setArea(turf.area(point));
    } else if (e.shape == "Line") {
      let cords = e.layer._latlngs;
      let ccds1 = cords.map((e) => [e.lng, e.lat]);
      var point = turf.lineString(ccds1, { name: "line 1" });
      setLength(turf.length(point, { units: "meters" }));
    }

    map.pm.disableDraw();
  });
  const togglePoint = () => {
    setMode("Point");

    map.eachLayer(function (layer) {
      if (layer.pm != null) {
        layer.remove();
      }
    });
    map.pm.enableDraw("Marker");
  };
  const togglePolygon = () => {
    setMode("Area");
    setUnits("sqm")
    map.eachLayer(function (layer) {
      if (layer.pm != null) {
        layer.remove();
      }
    });
    map.pm.enableDraw("Polygon");
  };
  const togglePolyline = () => {
    setMode("Line");
    setUnits("meter")
    map.eachLayer(function (layer) {
      if (layer.pm != null) {
        layer.remove();
      }
    });
    map.pm.enableDraw("Line");
  };

  const ChangeMap = () => {
    dispatch(
      closeTools({
        name: "Measure",
      })
    );
  };

  return (
    <React.Fragment>

      <div id="ediit" className={classes.Edit}>
        <div onClick={() => ChangeMap()}> <img src={close} className={classes.Close} /></div>
        <div className={classes.EditTools} onClick={() => togglePoint()}> <img src={markerloc} className={classes.ChildImages} /></div>
        <div className={classes.EditTools} onClick={() => togglePolyline()}><img src={line} className={classes.ChildImages} /></div>
        <div className={classes.EditTools} onClick={() => togglePolygon()}><img src={poly} className={classes.ChildImages} /></div>

        <div className={classes.ChildTextWrapper}>
          {mode == "Line" && (
            <select className={classes.SelectChild} onChange={(e) => setUnits(e.target.value)}>
              <option value={"meter"}>Meter</option>
              <option value={"feet"}>Feet</option>
              <option value={"km"}>Kilometer</option>
            </select>
          )}
          {mode == "Area" && (
            <select className={classes.SelectChild} onChange={(e) => setUnits(e.target.value)}>
              <option value={"sqm"}>Sq. Meter</option>
              <option value={"ha"}>Hectare</option>
              <option value={"sqkm"}> Sq. Kilometer</option>
            </select>
          )}
          {mode == "Point" && <>Lat: {latlng[0].toFixed(2)}| Long:{latlng[1].toFixed(2)}</>}


          {mode == "Line" && units == "meter" && <>Length: {length ? length.toFixed(2) : 0} meter</>}
          {mode == "Line" && units == "feet" && <>Length: {length ? (length * 3.28084).toFixed(2) : 0} Feet</>}
          {mode == "Line" && units == "km" && <>Length: {length ? (length / 1000).toFixed(2) : 0} Km</>}


          {mode == "Area" && units == "sqm" && <>Area: {area ? area.toFixed(2) : 0} sqm</>}
          {mode == "Area" && units == "ha" && <>Area: {area ? (area / 10000).toFixed(2) : 0} Ha</>}
          {mode == "Area" && units == "sqkm" && <>Area: {area ? (area / 1000000).toFixed(2) : 0} sqkm</>}
        </div>

        </div>


    </React.Fragment>
  );
};

export default Measure;
